// Cheap byte-level checks that do not need a PDF parser (kept out of the
// pdf-lib chunk so the initial page load stays small).

const ENCRYPT_TOKEN = [0x2f, 0x45, 0x6e, 0x63, 0x72, 0x79, 0x70, 0x74]; // "/Encrypt"

/**
 * Quick check for an /Encrypt entry without parsing the whole document.
 * May return a false positive in exotic files, never a false negative for
 * standard encrypted PDFs.
 */
export function looksEncrypted(bytes: Uint8Array): boolean {
  const first = ENCRYPT_TOKEN[0];
  const n = ENCRYPT_TOKEN.length;
  for (let i = bytes.indexOf(first); i !== -1 && i <= bytes.length - n; i = bytes.indexOf(first, i + 1)) {
    let match = true;
    for (let j = 1; j < n; j++) {
      if (bytes[i + j] !== ENCRYPT_TOKEN[j]) {
        match = false;
        break;
      }
    }
    if (match) return true;
  }
  return false;
}
